import classes from "./Divider.module.css";

const Divider = (props: { margin?: boolean }) => {
	const margins = props.margin === false ? " m-0" : " mb-75 mt-75";

	return <div className={classes.divider + margins}></div>;
};

export default Divider;
